// src/components/Header.js
import React from 'react';

function Header() {
  return (
   <div>
    <div className="paginacontainer"> 

<div className="progress-wrap">
  <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
    <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"/>
  </svg>
</div>

</div> 


  {/* <section>
    <div id="preloader">
      <div id="ctn-preloader" className="ctn-preloader ctn-preloader1">
        <div className="animation-preloader">
          <div className="spinner"></div>
          <div className="txt-loading">
            <span data-text-preloader="M" className="letters-loading">
              M
            </span>
            <span data-text-preloader="2" className="letters-loading">
              2
            </span>
            <span data-text-preloader="V" className="letters-loading">
              V
            </span>
            
          </div>
        </div>	
        <div className="loader-section-left loader-section section-left"></div>
        <div className="loader-section-right loader-section section-right"></div>
      </div>
    </div>
  </section> */}




  <div className="header-top">
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <div className="pera">
            <p><img src="assets/img/icons/header-top-span.png" alt=""/> Aligning Technology with Your Business Goals</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <header>
   <div className="header-area header-area1 header-area-all d-none d-lg-block" id="header">
     <div className="container">
       <div className="row">
         <div className="col-12">
           <div className="header-elements">
             <div className="site-logo">
               <a href="#">
                <img src="assets/img/logo/M2V Consulting.png" alt=""/>
               </a>
             </div>


             <div className="main-menu-ex main-menu-ex1">
              <ul>
                
                {/* <li><a href="/">Home</a>
               
                </li> */}

                <li className="dropdown-menu-parrent"><a href="/about_us">About Us</a>
                  {/* <ul>
                   <li><a href="/about_us">About - Light</a></li>
                   <li><a href="about2.html">About - Dark</a></li>
                  </ul> */}
                </li>

                <li className="dropdown-menu-parrent"><a href="/services">Our Services </a>
                  {/* <ul>
                   <li><a href="/services">Service <i className="fa-solid fa-angle-right"></i></a>
                     <ul>
                       <li><a href="#">Light <i className="fa-solid fa-angle-right"></i></a>
                         <ul>
                           <li><a href="/services">Service - Light</a></li>
                          </ul>
                         </li>
                         <li><a href="#">Dark <i className="fa-solid fa-angle-right"></i></a>
                           <ul>
                             <li><a href="service2.html">Service - Dark</a></li>
                            </ul>
                           </li>
                      </ul>
                     </li>

                     <li><a href="blog-details.html">Single Service <i className="fa-solid fa-angle-right"></i></a>
                       <ul>
                         <li><a href="#">Light <i className="fa-solid fa-angle-right"></i></a>
                           <ul>
                            <li><a href="service-details-left.html">Service Left - Light</a></li>
                            <li><a href="service-details-right.html">Service Right - Light</a></li>
                            <li><a href="#">Service Details - Light</a></li>
                            </ul>
                           </li>
                           <li><a href="#">Dark <i className="fa-solid fa-angle-right"></i></a>
                             <ul>
                              <li><a href="service-details-left2.html">Service Left - Dark</a></li>
                              <li><a href="service-details-right2.html">Service Right - Dark</a></li>
                              <li><a href="service-details2.html">Service Details - Dark</a></li>
                              </ul>
                             </li>
                        </ul>
                       </li>

                  </ul> */}
                </li>

              

              

               {/* <li className="dropdown-menu-parrent"><a href="#">Our Projects </a> */}
               
              {/* </li> */}
              <li className="dropdown-menu-parrent"><a href="/contact_us">Contact Us </a>
               
               </li>
                  
              </ul>

             </div>



             <div className="header1-buttons">
                  <div className="contact-btn">
                    <div className="icon">
                      <img src="assets/img/icons/header1-icon.png" alt=""/>
                    </div>
                    <div className="headding">
                      <p>Call Us</p>
                      <a href="tel:+919211047778">+91 9211047778</a>
                    </div>
                  </div>
                  <div className="button">
                    <a className="theme-btn1" href="/contact_us">Contact Us <span><i className="fa-solid fa-arrow-right"></i></span></a>
                  </div>
             </div>

           </div>
         </div>
       </div>
     </div>
   </div>
 </header>

     <div className="mobile-header d-block d-lg-none ">
      <div className="container-fluid">
        <div className="col-12">
          <div className="mobile-header-elements">
            <div className="mobile-logo">
              <a href="/"><img src="assets/img/logo/M2V Consulting.png" alt=""/></a>
            </div>
            <div className="mobile-nav-icon">
              <i className="fa-duotone fa-bars-staggered"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div className="mobile-sidebar d-block d-lg-none">
      <div className="logo-m">
        <a href="/"><img src="assets/img/logo/M2V Consulting.png" alt=""/></a>
      </div>
      <div className="menu-close">
        <i className="fa-solid fa-xmark"></i>
      </div>
      <div className="mobile-nav">
  
        <ul>
          <li className=""><a href="/">Home </a> 
           
        </li>
        <li><a href="/about_us">About Us</a></li>
        <li className=""><a href="/services">Our Services</a> 
         
      </li>

      <li className=""><a href="/contact_us">Contact Us</a> 
         
      </li>

        </ul>
        
        <div className="mobile-button">
          <a className="menu-btn2" href="/services">Learn More <span><i className="fa-solid fa-arrow-right"></i></span></a>
        </div>

        <div className="single-footer-items">
          <h3>Contact Us</h3>

          {/* <div className="contact-box">
            <div className="icon">
              <img src="assets/img/icons/footer1-icon1.png" alt=""/>
            </div>
            <div className="pera">
              <a href="tel:+919211047778">+91 9211047778</a>
            </div>
          </div> */}

          <div className="contact-box">
            <div className="icon">
              <img src="assets/img/icons/footer1-icon2.png" alt=""/>
            </div>
            <div className="pera">
              <a href="tel:+919211047778">+91 9211047778</a>
            </div>
          </div>

          <div className="contact-box">
            <div className="icon">
              <img src="assets/img/icons/footer1-icon3.png" alt=""/>
            </div>
            <div className="pera">
              <a href="mailto:admin@techxen.org">info@m2v-consulting.com</a>
            </div>
          </div>

          <div className="contact-box">
            <div className="icon">
              <img src="assets/img/icons/footer1-icon4.png" alt=""/>
            </div>
            <div className="pera">
              <a href="mailto:admin@techxen.org">www.m2v-consulting.org</a>
            </div>
          </div>

     </div>

        <div className="contact-infos">
          <h3>Our Location</h3>
          <ul className="social-icon">
            <li><a href="#"><i className="fa-brands fa-linkedin-in"></i></a></li>
            <li><a href="#"><i className="fa-brands fa-x-twitter"></i></a></li>
            <li><a href="#"><i className="fa-brands fa-youtube"></i></a></li>
            <li><a href="#"><i className="fa-brands fa-instagram"></i></a></li>
       </ul>
        </div>

      </div>
    </div>

   
   </div>
  );
}

export default Header;
